import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';
var LaunchpageComponent = (function () {
    function LaunchpageComponent(router, platformLocation) {
        this.router = router;
        this.platformLocation = platformLocation;
    }
    LaunchpageComponent.prototype.ngOnInit = function () {
        console.log('进入launch-page');
        var targetUrl = this.platformLocation['location']['href'].split('?')[1] ? this.platformLocation['location']['href'].split('?')[1] : '';
        var param = '';
        if (typeof window.localStorage !== 'undefined' &&
            window.localStorage.getItem('transtalen-token') &&
            window.localStorage.getItem('transtalenuserid')) {
            if (targetUrl) {
                param = '&' + targetUrl;
            }
            this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/ddilearner/v1/user/authorize?token=' + window.localStorage.getItem('transtalen-token') + param;
        }
        else {
            if (targetUrl) {
                targetUrl = '?' + targetUrl;
            }
            this.platformLocation['location']['href'] = this.platformLocation['location']['origin'] + '/new-login' + targetUrl;
        }
    };
    LaunchpageComponent.prototype.ngAfterViewInit = function () {
    };
    return LaunchpageComponent;
}());
export { LaunchpageComponent };



// WEBPACK FOOTER //
// ./src/app/launchpage.component.ts.pre-build-optimizer.js